import { env } from '@monorepo/env'
import { auth } from '@monorepo/utils/firebase'
import { signInWithCustomToken } from '@monorepo/utils/firebase'
import { handleAuthWithCredential } from '../handleAuthWithCredential'

const CLIENT_ID = env.EXPO_PUBLIC_LINKEDIN_CLIENT_ID
const REDIRECT_URI = `${env.EXPO_PUBLIC_API_URL}/auth/linkedin`

export const signInWithLinkedIn = async () => {
  // For web platforms, use redirect flow

  if (typeof window !== 'undefined') {
    const state = Math.random().toString(36).substring(7) // CSRF protection
    const linkedInAuthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&state=${state}&scope=openid%20profile%20w_member_social%20email`

    window.location.href = linkedInAuthURL
    return
  }

  // For mobile platforms, you would need to implement deep linking
  // and handle the callback from LinkedIn
  throw new Error('LinkedIn sign-in not implemented for mobile platforms')
}

// Function to handle the callback from the API after LinkedIn OAuth
export const handleLinkedInCallback = async (customToken: string, userData: any) => {
  try {
    // Sign in with the custom token received from the API
    const userCredential = await signInWithCustomToken(auth(), customToken)

    return {
      provider: 'linkedin',
      user: userCredential.user,
      userData: userData,
    }
  } catch (error) {
    console.error('Error handling LinkedIn callback:', error)
    throw error
  }
}

// Function to handle LinkedIn callback from URL parameters
// Call this in your /auth/linkedin/callback route
export const completeLinkedInSignIn = async () => {
  try {
    console.log('[LinkedIn] completeLinkedInSignIn: starting, url =', window.location.href)

    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')

    console.log('[LinkedIn] completeLinkedInSignIn: token present =', !!token)

    if (!token) {
      throw new Error('Invalid LinkedIn callback - missing token')
    }

    console.log('[LinkedIn] completeLinkedInSignIn: calling signInWithCustomToken')
    const userCredential = await signInWithCustomToken(auth(), token)
    console.log('[LinkedIn] completeLinkedInSignIn: signInWithCustomToken succeeded, uid =', userCredential.user.uid)
    console.log('[LinkedIn] completeLinkedInSignIn: user.isAnonymous =', userCredential.user.isAnonymous)
    console.log('[LinkedIn] completeLinkedInSignIn: user.providerData =', JSON.stringify(userCredential.user.providerData))

    return {
      provider: 'linkedin',
      user: userCredential.user,
    }
  } catch (error) {
    console.error('[LinkedIn] completeLinkedInSignIn error:', error)
    throw error
  }
}
